import React from 'react';

import { ERoles } from './constants';

import RequestReservationCard from './RequestReservationCard';

function RequestReservationCardContainerMNO() {
	return <RequestReservationCard role={ERoles.mno} />;
}

export default RequestReservationCardContainerMNO;
